import './Switch.css';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { qsToObject } from '../../../utils/querystring';
import addQueryString, { removeQueryString } from '../../Listing';
import { isNil } from '../../../utils/IsNil';
import { splitter } from '../../RecommendationListing';
import { TYPE } from '../../../utils/constants';
import { get } from '../../../utils';
const Switch = _ref => {
  let {
    tagsToDisplay,
    fields,
    rtl,
    moveToSlide
  } = _ref;
  const history = useHistory();
  const location = useLocation();
  const queryParams = qsToObject(location.search);
  const queriesType = queryParams[TYPE];
  const type = 'radio';
  const checkboxes = React.useRef();
  const setChecked = (key, index) => {
    let isChecked = false;
    if (index === 0 && isNil(queriesType)) {
      addQueryString(TYPE, key, history);
      isChecked = true;
    }
    if (queriesType && queriesType.replaceAll("+", " ") === key) {
      isChecked = true;
    }
    return isChecked;
  };
  const submitFilters = e => {
    const checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
    let selectedCheckboxes = [];
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
    }
    selectedCheckboxes = selectedCheckboxes.join(splitter);
    addQueryString(TYPE, selectedCheckboxes, history);
    moveToSlide(0);
  };
  useEffect(() => {
    return () => {
      removeQueryString(TYPE, history);
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select switch"
  }, /*#__PURE__*/React.createElement("div", {
    ref: checkboxes,
    className: `g-checkbox g-checkbox--mob-scroll ${type === 'radio' ? 'g-checkbox-notick' : ''}`
  }, tagsToDisplay.length ? tagsToDisplay.map((key, index) => {
    const tabTitle = get(get(fields, "data.datasource.items")[index], 'tabTitle.jss.value');
    return /*#__PURE__*/React.createElement("div", {
      key: key + index,
      className: "g-checkbox__item"
    }, /*#__PURE__*/React.createElement("input", {
      tabIndex: 0,
      value: key,
      defaultChecked: setChecked(key, index),
      type: type,
      className: `fp__checkbox`,
      id: `gct1-${key + index}`,
      name: "gct1",
      title: tabTitle || key,
      onChange: event => {
        submitFilters(event);
      },
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          event.preventDefault();
          event.target.checked = !event.target.checked;
          submitFilters(event);
        }
      }
    }), /*#__PURE__*/React.createElement("label", {
      className: "body-small g-checkbox__label",
      htmlFor: `gct1-${key + index}`
    }, tabTitle || key));
  }) : null)));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyle : ltrStyle}`
  }, children);
};
export default Switch;
export const commonStyles = "c1s1tdyb";
const ltrStyle = "l1baadki";
const rtlStyle = "r1y18g5o";